// dependencies
import { Link } from "react-router-dom"
import { useState } from "react";

// components
import Tag from "../../ui/Tag"

// styles
import styles from "./css/ProjectCard.module.css";

const tagColors = {
    "Personal Project": { bg: "#232338", text: "#fff" },
    "Completed": { bg: "#4f3d73", text: "#fff" },
    "Freelance Project": { bg: "#97119c", text: "#fff" },
    "Uni Project": { bg: "#af3d73", text: "#fff" },
    "Active": { bg: "#60b1cc", text: "#fff" },
};

export const ProjectCard = ({ id, title, description, thumbnail, tags }) => {
    const [imgLoaded, setImgLoaded] = useState(false);

    return (
        <Link to={`/projects/${id}`} className={styles.projectLink}> 
        <div className={styles.projectCardContainer}>
            <div className={styles.imgContainer}>
                <img 
                    src={thumbnail} 
                    alt="img-title" 
                    className={`${styles.thumbnail} ${imgLoaded ? styles.loaded : ""}`}
                    onLoad={() => {setImgLoaded(true)}}
                />
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.tags}>
                    {tags.map((tag) => {
                        const { bg, text } = tagColors[tag] || tagColors.Default;
                        return (
                            <Tag 
                                key={tag} 
                                text={tag} 
                                fontSize="0.8rem" 
                                backgroundColor={bg} 
                                color={text} 
                            />
                        );
                    })}
                </div>

                {/* title and content */}
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
            </div>
        </div>
        </Link>
    )
}
